var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "px",
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#599636",
      fillOpacity: 1
    },
    d: "m19.875.11 1.066 2.003c.243.371.5.7.809 1.004.89.895 1.742 1.828 2.504 2.832 1.808 2.375 3.027 5.012 3.898 7.864a19.25 19.25 0 0 1 .828 5.34c.09 5.402-1.765 10.042-5.5 13.898-.609.61-1.261 1.176-1.96 1.68-.372 0-.547-.286-.7-.547a4.5 4.5 0 0 1-.543-1.57c-.132-.653-.218-1.305-.175-1.981v-.305C20.07 30.262 19.746.262 19.875.11zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#6cac48",
      fillOpacity: 1
    },
    d: "M19.875.043c-.043-.09-.086-.023-.133.02.024.437-.129.828-.367 1.203-.266.367-.61.652-.96.957-1.938 1.675-3.462 3.703-4.685 5.968-1.625 3.051-2.46 6.32-2.699 9.762-.11 1.242.39 5.621.785 6.883 1.067 3.355 2.985 6.168 5.47 8.61.609.585 1.26 1.132 1.937 1.656.195 0 .215-.176.261-.305a5.84 5.84 0 0 0 .196-.852l.437-3.27zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#c2bfbf",
      fillOpacity: 1
    },
    d: "M20.941 36.055c.043-.5.286-.914.547-1.328-.261-.11-.457-.325-.61-.567a3.864 3.864 0 0 1-.327-.719c-.305-.914-.367-1.875-.457-2.808v-.567c-.11.086-.13.829-.13.938a21.897 21.897 0 0 1-.394 2.941c-.062.39-.11.785-.347 1.133 0 .043 0 .086.02.152.394 1.157.5 2.333.566 3.532v.437c0 .52-.02.41.414.586.172.067.367.086.543.219.132 0 .152-.11.152-.2l-.063-.718v-2.004c-.023-.348.043-.695.086-1.023zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.70d9061ffeae527fba0db6d60698e045.svg";
export { ForwardRef as ReactComponent };